module.exports = __webpack_public_path__ + "img/10n.a43e74e2.png";